// extracted by mini-css-extract-plugin
module.exports = {"processingContainer":"Processing_processingContainer__2qvzV","title":"Processing_title__2-nbI","subtitle":"Processing_subtitle__2nwxx"};